// import '../Scss/Frontend/Elements/PagePreloader.scss';
import $ from 'jquery';

$(window).on('load pageshow', function() {
  setTimeout(function() {
    $('.pg-preloader').fadeOut(200);
  }, 600)
})

$('.linkWrapper, .item.product a').on('click', function() {
  setTimeout(function() {
    $('.pg-preloader').fadeIn(200);
  }, 600)
})
